import { useTranslation } from 'libs/i18n'
import { useUserRoles } from 'shared/hooks'

export const useActionFilters = (isDisabled: boolean) => {
	const { t } = useTranslation()
	const { isStaff } = useUserRoles()

	return [
		{
			id: 'actions',
			label: t('Actions'),
			placeholder: t('Default'),
			options: [
				{
					value: 'export',
					label: t('Export')
				},
				...(isStaff
					? [
							{
								value: 'bulkStatus',
								label: t('Mark as paid'),
								isDisabled
							}
						]
					: [])
			]
		}
	]
}
